export enum SelectionType {
  None = 'None',
  Single = 'Single',
  Multi = 'Multi',
}
